import { defineMessages } from 'react-intl';

export const phoneValidationMessages = defineMessages({
  fallback: {
    defaultMessage: 'Enter a valid phone number',
    description: 'Generic fallback error message shown when the phone number format is invalid',
    id: '+vtdGU',
  },
  notANumber: {
    defaultMessage: "This doesn't appear to be a phone number",
    description: 'Error message when the input contains no recognizable phone digits',
    id: '7Lrd8a',
  },
  tooShort: {
    defaultMessage: 'Phone number is too short',
    description: 'Error message when the phone number has too few digits',
    id: 'zHQ8WH',
  },
  tooLong: {
    defaultMessage: 'Phone number is too long',
    description: 'Error message when the phone number has too many digits',
    id: '/netLb',
  },
  invalidCountry: {
    defaultMessage: 'Phone number is not valid for the selected country',
    description: 'Error message when the phone number does not match the expected country format',
    id: 'UrLuW2',
  },
});
